/** @jsx jsx */ /** @jsxRuntime classic */

import React, { useState } from 'react';
import { jsx } from "theme-ui";

const EventsStacked = (props) => {
  const months = { 1: "Jan", 2: "Feb", 3: "Mar", 4: "Apr", 5: "May", 6: "Jun", 7: "Jul", 8: "Aug", 9: "Sep", 10: "Oct", 11: "Nov", 12: "Dec" };
  const [isHovered, setIsHovered] = useState(false);

  const barStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    padding: '15px 20px',
    marginBottom: '10px',
    
    backgroundColor: '#D5B3E7',
    border: isHovered ? '1px solid #6E4884' : '1px solid #d3b4ec',
    borderRadius: '15px',
    boxShadow: isHovered ? '0px 4px 12px rgba(110, 72, 132, 0.4)' : '0px 2px 8px rgba(0, 0, 0, 0.2)',
    
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    transform: isHovered ? 'translateY(-2px)' : 'translateY(0)',
  };

  const dateContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '70px',
    padding: '10px',
    backgroundColor: 'white',
    borderRadius: '10px',
    border: '2px solid #6E4884',
    flexShrink: 0,
  };

  const monthStyle = {
    fontSize: '0.9em',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#6E4884',
    margin: 0,
    fontFamily: 'Poppins',
  };

  const dayStyle = {
    fontSize: '1.8em',
    color: 'black',
    fontWeight: 'bold',
    margin: 0,
    fontFamily: 'Poppins',
  };

  const textContainerStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  };

  const headingStyle = {
    margin: 0,
    fontSize: '1.2em',
    fontWeight: 'bold',
    color: 'black',
    fontFamily: 'Poppins',
  };

  const timeStyle = {
    margin: 0,
    fontSize: '0.95em',
    color: '#333',
    fontFamily: 'Poppins',
  };

  const locationStyle = {
    margin: 0,
    fontSize: '0.95em',
    color: '#6E4884',
    fontWeight: '500',
    fontFamily: 'Poppins',
  };

  return (
    <div 
      style={barStyle} 
      onClick={props.onClick} 
      onMouseEnter={() => setIsHovered(true)} 
      onMouseLeave={() => setIsHovered(false)}
    >
      <div style={dateContainerStyle}>
        <p style={monthStyle}>{months[props.month]}</p>
        <p style={dayStyle}>{props.day}</p>
      </div>
      
      <div style={textContainerStyle}>
        <h3 style={headingStyle}>{props.heading}</h3>
        <p style={timeStyle}>{`${props.startTime} - ${props.endTime}`}</p>
        <p style={locationStyle}>{props.location && props.location.split(',')[0]}</p>
      </div>
    </div>
  );
};

export default EventsStacked;